import apiClient from './client'
import type { User } from '@/types'

interface ListUsersResponse {
  data: User[]
  total: number
  limit: number
  offset: number
}

interface CreateUserRequest {
  email: string
  password: string
  name: string
  role: 'admin' | 'viewer'
}

interface UpdateUserRequest {
  email?: string
  name?: string
  role?: 'admin' | 'viewer'
  active?: boolean
}

interface ChangePasswordRequest {
  current_password?: string
  new_password: string
}

export const usersApi = {
  list: async (params?: {
    search?: string
    role?: string
    active?: boolean
    limit?: number
    offset?: number
  }): Promise<ListUsersResponse> => {
    const response = await apiClient.get<ListUsersResponse>('/users', { params })
    return response.data
  },

  getById: async (id: string): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${id}`)
    return response.data
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post<User>('/users', data)
    return response.data
  },

  update: async (id: string, data: UpdateUserRequest): Promise<User> => {
    const response = await apiClient.put<User>(`/users/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`)
  },

  changePassword: async (id: string, data: ChangePasswordRequest): Promise<void> => {
    await apiClient.put(`/users/${id}/password`, data)
  },
}
